
export default {

  addFavorite (state, articleVariation) {
    state.allFavorites.push(articleVariation)
  },

  removeFavorite (state, articleVariation) {
    let favorites = []
    state.allFavorites.forEach(favorite => {
      if ( favorite.id !== articleVariation.id ) {
        favorites.push(favorite)
      }
    })
    state.allFavorites = favorites
  },

  setAllFavorites (state, articleVariations) {
    state.allFavorites = articleVariations
  },

  setCurrentArticle (state, article) {
    state.current = article
  }
}